module.exports = __webpack_public_path__ + "static/media/nft-26.3fb47964.jpg";